import { 
    BaseTable, 
    Card, 
    FooterMenu, 
    HeaderMenu, 
    Loading, 
    PaginationData,
    Select, 
    TableHeader, 
    TableHeaderSort,
    DateInput

} from "components";
import { useApprovalList, defaultValue } from "./utils";
import { useState } from "react";
import { FillType } from "./types";
import { ExportExcelBuildApproval, ExportPDFBuildApproval, Item } from "./components";
import { APPROVAL_OPTIONS, exportPdf } from "utils";
import moment from "moment";

export default function ApproveBuild() {
  
  const [pagination, setPagination] = useState<FillType>({
    ...defaultValue,
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().endOf("month").format("YYYY-MM-DD"),
    location_id: '0',
    approve_status: '0',
    group_id: '0',
  });

  const { data, isLoading, refetch } = useApprovalList(pagination)

  const header: TableSorting[] = [
    { title: "NO", sort: false },
    { title: "BUILD ID#", sort: true, colspan: 2 },
    { title: "DATE", sort: true },
    { title: "DESCRIPTION", sort: true },
    { title: "QTY BUILD", sort: true },
    { title: "UNIT", sort: true },
    { title: "LOCATION", sort: true },
    { title: "STATUS APPROVE", sort: false },
    { title: "DATE APPROVE", sort: true },
  ];
  const sortMapping: Record<string, string> = {
    "BUILD ID#": "buildid",
    "DATE": "builddate",
    "DESCRIPTION": "description",
    "QTY BUILD": "qtybuild",
    "UNIT": "unit",
    "LOCATION": "location",
    "DATE APPROVE": "dateapprove",
  };
  const handleSort = (item: string, sortType: string) => {
    const sortParam = sortMapping[item] ? `${sortMapping[item]}:${sortType}` : "";
    setPagination({ ...pagination, sort: sortParam });
  };

  return (
    <section className="container my-2">
      <section>
        <HeaderMenu title="BUILD APPROVAL" />

        <section>
          <section className="mt-2">
            <Card>
              <Card.Body>
                <section className="lg:flex lg:items-start gap-3 mt-2 w-full">
                  <DateInput
                    label="START DATE"
                    wrapperClassName="lg:w-[180px]"
                    onChange={(date) =>
                      setPagination({
                        ...pagination,
                        start_date: moment(date).format("YYYY-MM-DD"),
                      })
                    }
                    selected={
                      pagination.start_date ? moment(pagination.start_date).toDate() : null
                    }
                  />

                  <DateInput
                    label="END DATE"
                    wrapperClassName="lg:w-[180px]"
                    onChange={(date) =>
                      setPagination({
                        ...pagination,
                        end_date: moment(date).format("YYYY-MM-DD"),
                      })
                    }
                    selected={
                      pagination.end_date ? moment(pagination.end_date).toDate() : null
                    }
                  />

                   <Select
                    label="APPROVED"
                    className="lg:w-[200px]"
                    placeholder="Select Approval"
                    options={APPROVAL_OPTIONS}
                    value={APPROVAL_OPTIONS.find(item => item.value === pagination.approval_status)}
                    onChange={e => setPagination({ ...pagination, approval_status: e?.value })}
                  />
                </section>

               
              </Card.Body>
            </Card>
          </section>
        </section>

        <section className="mt-2">
          <Card>
            <Card.Body>
              <div className="overflow-x-auto max-h-[calc(100vh-460px)]">
                <BaseTable>
                  <TableHeader>
                    <tr>
                      <TableHeaderSort
                        title={header}
                        onSort={(item, sortType) => handleSort(item, sortType)}
                      />
                    </tr>
                  </TableHeader>
                  <tbody>
                    {isLoading || data?.payload?.listfile?.length === 0 ? (
                      <tr>
                        <td colSpan={12} className="text-center">
                          <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                        </td>
                      </tr>
                    ) : data?.payload?.listfile.map((item, key: number) => (
                      <Item
                        data={item}
                        index={key}
                        refetch={refetch}
                        pagination={pagination}
                      />
                    ))}
                  </tbody>
                </BaseTable>
                <div className="mt-3">
                  <PaginationData data={data.payload} pagination={pagination} setPagination={setPagination} />
                </div>
              </div>
            </Card.Body>
          </Card>
        </section>

        <section className="mt-2">
          <FooterMenu
            export={{
              actiontype: "export",
              onClick: () => {
                return ExportExcelBuildApproval({
                  data: data?.payload?.listfile,
                  module: "INVENTORY", 
                  title: "TRANSACTION BUILD APPROVAL",
                  fileName: "build_approval"
                });
                }
              }}
            pdf={{
              actiontype: "pdf",
              onClick: () => {
                exportPdf({
                  documentComponent: <ExportPDFBuildApproval data={data?.payload?.listfile} />,
                  fileName: "build_approval"
                });
              }
            }}
          />
        </section>
      </section>
    </section>
  )
}

type TableSorting = {
  title: string; 
  sort: boolean
  align?: string; 
  colspan?: number; 
}